let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("i2OFv"), load("7TRGL")]).then(() => parcelRequire('jOLOx'));